import { MailInboxItem } from '../../types/MailInbox';
import createInfiniteScrollStore from '../infiniteScrollStore';

export const useMailInboxStore = createInfiniteScrollStore<MailInboxItem>();
